import React, { useMemo, useState } from 'react';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { speech } from '../../../../javascript/sport/sport-function';
import { SPORT_BASE, NAV_CONTROL } from '../../../../javascript/services/globalVars';
import useIsLandscape from '../../../../javascript/utils/use-is-landscape.js';
import style from './serving-indicator.style.module.scss';
// import DBHandler from '../../../../javascript/index-db/db-handler';
// import { Timestamp } from '../../../../javascript/utils/utils';

function ServingIndicator(Props) {
   const isLandscape = useIsLandscape();
   const default_color = { color: '#7b7b7b05' };
   const default_side_color = { color: '#FFF' };
   const [serverSide, setServerSide] = useState(() => '');
   const [sideColor, setSideColor] = useState(() => default_side_color);
   const [singleHelper, setSingleHelper] = useState(() => false);
   const [doublesHelper, setDoublesHelper] = useState(() => false);
   const [singleHelperJSX, setSingleHelperJSX] = useState('');
   const [doublesHelperJSX, setDoublesHelperJSX] = useState('');
   const [servingSide, setServingSide] = useState(() => 1);
   const [doublesHelperType, setDoublesHelperType] = useState(() => 1);
   const [showDoublesHelper, setShowDoublesHelper] = useState(() => false);
   const [showServerIndicator, setShowServerIndicator] = useState(() => '');

   const updateServingSate = (servingState) => {
      if (typeof servingState !== 'undefined') {
         let setColor;
         let serverSide = '';
         let serverColor1 = default_color;
         let serverColor2 = default_color;

         if (servingState.side === Props.pos) {
            setShowDoublesHelper(true);
            if (typeof Props.colorTable !== 'undefined') {
               if (Props.pos === 1) {
                  if (servingState.side_state_1.serving_player === 1) {
                     setColor = Props.colorTable[0];
                     serverColor1 = { color: setColor };
                  } else if (servingState.side_state_1.serving_player === 2) {
                     setColor = Props.colorTable[2];
                     serverColor2 = { color: setColor };
                  }
               } else if (Props.pos === 2) {
                  if (servingState.side_state_2.serving_player === 1) {
                     setColor = Props.colorTable[1];
                     serverColor1 = { color: setColor };
                  } else if (servingState.side_state_2.serving_player === 2) {
                     setColor = Props.colorTable[3];
                     serverColor2 = { color: setColor };
                  }
               }

               if (doublesHelperType === 2) {
                  if (Props.pos === 1) {
                     setSideColor({ color: "var(--player-a-color)" });
                  } else if (Props.pos === 2) {
                     setSideColor({ color: "var(--player-b-color)" });
                  }
               } else {
                  setSideColor({ color: setColor });
               }

               serverSide = servingState.inner_side === 1 ? 'L' : 'R';
            }
         } else {
            setShowDoublesHelper(false);
         }

         const servingConfig = SPORT_BASE.sport_object.scoring.serving.config; // Generated From Sports JSON Config

         // console.error('Props.servingState: ', Props.servingState);
         
         // console.error('servingConfig: ', servingConfig);

         if (typeof servingConfig.doubles_helper !== 'undefined' &&
            servingConfig.doubles_helper.value === true &&
            servingConfig.doubles_helper.type === 'initial' &&
            Props.servingState.type === 'doubles'
         ) {
            const players = SPORT_BASE.sport_object.scoring.state.match.players;
            if (typeof players.teams[Props.pos - 1].players[0] !== 'undefined') {
               const initial = players.teams[Props.pos - 1].players[0].initial;
               setSingleHelperJSX(<div style={serverColor1}> {initial} </div>);
            }
            if (typeof players.teams[Props.pos - 1].players[1] !== 'undefined') {
               const initial = players.teams[Props.pos - 1].players[1].initial;
               setDoublesHelperJSX(<div style={serverColor2}> {initial} </div>);
            }
         } else {
            setSingleHelperJSX(<FontAwesomeIcon style={serverColor1} icon={faUser} />);
            setDoublesHelperJSX(<FontAwesomeIcon style={serverColor2} icon={faUser} />);
         }
         setServerSide(serverSide);
      }
   
   }
   useMemo(() => {
      setSingleHelper(false);
      setDoublesHelper(false);
      
      // Add null checks to prevent runtime errors
      if (!Props.servingState || !Props.servingState.side_state_1 || !Props.servingState.side_state_2) {
         setServingSide(0);
         return;
      }
      
      const serving_side = Props.pos === 1 ? Props.servingState.side_state_1.serving_side : Props.servingState.side_state_2.serving_side;


      setServingSide(serving_side);

      // console.log('SPORT_BASE.sport_object.scoring.serving_type: ', SPORT_BASE.sport_object.scoring.serving_type)

      if (SPORT_BASE.sport_object.scoring.serving_type === 'pickleball') {
         const game_options = SPORT_BASE.sport_object.scoring.get_setting({ setting_name: 'game_options' });
         if (game_options.value === 1 && SPORT_BASE.sport_object.scoring.state.serving.type === 'doubles') {
            setDoublesHelperType(2);
         } else {
            setDoublesHelperType(1);
         }
      } else {
         setDoublesHelperType(1);
      }

      // Access serving settings from the scoring object instead of servingState
      const servingConfig = SPORT_BASE.sport_object.scoring.serving.config;
      
      if (typeof servingConfig.hide_server_indicator !== 'undefined') {
         if (servingConfig.hide_server_indicator.value) {
            setShowServerIndicator(style.hidden);
         } else {
            setShowServerIndicator('');
         }
      }

      let server_icons_config = false;

      // console.warn('[DEBUG]servingState: ', Props.servingState);
      if(typeof Props.servingState.get_server_icons_config === 'function') {
         server_icons_config = Props.servingState.get_server_icons_config();
      }

      if (typeof servingConfig.single_helper !== 'undefined' && server_icons_config) {
         setSingleHelper(servingConfig.single_helper.value);
      }

      if (typeof servingConfig.doubles_helper !== 'undefined' && servingConfig.doubles_helper.value === true && Props.servingState.type === 'doubles' && server_icons_config) {
         setSingleHelper(true);
         setDoublesHelper(true);
      }
      return updateServingSate(Props.servingState);
   }, [Props.servingState, Props.update])

   const changeInnerSide = async (innerSide) => {
      if (SPORT_BASE.sport_object.scoring.state.serving.player === Props.pos && SPORT_BASE.sport_object.scoring.state.serving.inner_side === innerSide) {
         if (innerSide === 1) {
            speech('Left side', false);
         } else if (innerSide === 2) {
            speech('Right side', false);
         }
      }

      SPORT_BASE.sport_object.scoring.state.serving.updateServer(Props.pos, innerSide);
      SPORT_BASE.sport_object.scoring.scoring.flush_state();
      SPORT_BASE.sport_object.scoring.scoring.update_match_state('running');
      await SPORT_BASE.saveActiveMatch();
      NAV_CONTROL.refreshScore();
   }

   const changeServeIndicator = async (player) => {
      if (Props.pos === 1 && player === 2) {
         player = 3;
      } else if (Props.pos === 2 && player === 1) {
         player = 2;
      } else if (Props.pos === 2 && player === 2) {
         player = 4;
      }

      // console.log('changeServeIndicator: ', player);
      SPORT_BASE.sport_object.scoring.state.serving.updatePlayer(player);
      SPORT_BASE.sport_object.scoring.scoring.flush_state();
      SPORT_BASE.sport_object.scoring.scoring.update_match_state('running');
      await SPORT_BASE.saveActiveMatch();
      await SPORT_BASE.saveGameState();
      await SPORT_BASE.updateGameStateTimestamp();
      NAV_CONTROL.refreshScore();
   }

   return (
      <div className={isLandscape ? style.scoreServe : style.scoreServePortrait}>

         <div onClick={() => { changeInnerSide(1) }} style={serverSide === 'L' ? sideColor : {}} className={`${showServerIndicator} ${style.serveSide} ${serverSide === 'L' ? style.serveSideActive : ''}`}>L</div>
         <div className={style.serveIndicatorWrap} >
            {doublesHelperType === 1 ? (
               <>
               {singleHelper ? <div onClick={() => { changeServeIndicator(1) }} className={style.serveIndicator}> {singleHelperJSX} </div> : null}
               {doublesHelper ? <div onClick={() => { changeServeIndicator(2) }} className={style.serveIndicator}> {doublesHelperJSX} </div> : null}
               </>
            ): (
               <>
               {showDoublesHelper ? (
                  <>
                  {servingSide === 1 ? (
                     <div onClick={() => { changeServeIndicator(2) }} className={style.serveIndicator}> 1 </div>
                  ) : (
                     <div onClick={() => { changeServeIndicator(1) }} className={style.serveIndicator}> 2 </div>
                  )}
                  </>
               ) : null}
               </>
            )}
         </div>
         <div onClick={() => { changeInnerSide(2) }} style={serverSide === 'R' ? sideColor : {}} className={`${showServerIndicator} ${style.serveSide} ${serverSide === 'R' ? style.serveSideActive : ''}`}>R</div>
      </div>
   );
}

export default ServingIndicator;